import { createBrowserRouter } from "react-router-dom";
import Auth from "./Pages/Auth/Auth";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Login from "./Pages/Auth/Login/Login";
import Key from "./Pages/Key/Key";
import Packages from "./Pages/Packages/Packages";
import Topup from "./Pages/Topup/Topup";
import Payment from "./Pages/Payment/Payment";
import Register from "./Pages/Auth/Register/Register";
import ForgetPass from "./Pages/Auth/ResetPass/ForgetPass";
import ResetPass from "./Pages/Auth/ResetPass/ResetPass";
import Verify from "./Pages/Auth/Verify/Verify";
import Me from "./Pages/Me/Me";
import Users from "./Pages/Users/Users";
import Location from "./Pages/Location/Location";
import Box from "./Pages/Box/Box";
import Line from "./Pages/Line/Line";
import Proxy from "./Pages/Proxy/Proxy";
import Doc from "./Pages/Doc/Doc";
import AppList from "./Pages/App/AppList";
import DetailLocation from "./Pages/Location/Detail";
import DetailBox from "./Pages/Box/Detail";
import DetailLine from "./Pages/Line/Detail";
import DetailProxy from "./Pages/Proxy/Detail";
import User from "./Pages/User/User";
import DetailUser from "./Pages/User/Detail";
import Privacy from "./Pages/PrivacyTerms/Privacy";
import Terms from "./Pages/PrivacyTerms/Terms";
import Partner from "./Pages/Partner/Partner";
import DetailPartner from "./Pages/Partner/Detail";
import PTopup from "./Pages/PartnerTopup/PTopup";
import CheckProxy from "./Pages/CheckProxy/CheckProxy";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Auth component={Packages} isGuest={true}/>,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/forget",
    element: <ForgetPass />,
  },
  {
    path: "/reset-password",
    element: <ResetPass />,
  },
  {
    path: "/verify",
    element: <Verify />,
  },
  {
    path: "/dashboard",
    element: <Auth component={Dashboard}/>,
  },
  {
    path: "/package",
    element: <Auth component={Packages} isGuest={true}/>,
  },
  {
    path: "/key",
    element: <Auth component={Key}/>,
  },
  {
    path: "/topup",
    element: <Auth component={Topup}/>,
  },
  {
    path: "/p_topup",
    element: <Auth component={PTopup}/>,
  },
  {
    path: "/payment",
    element: <Auth component={Payment}/>,
  },
  {
    path: "/me",
    element: <Auth component={Me}/>
  },
  {
    path: "/users/:id",
    element: <Auth component={DetailUser}/>
  },
  {
    path: "/users",
    element: <Auth component={User}/>
  },
  {
    path: "/location/:id",
    element: <Auth component={DetailLocation}/>
  },
  {
    path: "/location",
    element: <Auth component={Location}/>
  },
  {
    path: "/box/:id",
    element: <Auth component={DetailBox}/>
  },
  {
    path: "/box",
    element: <Auth component={Box}/>
  },
  {
    path: "/line/:id",
    element: <Auth component={DetailLine}/>
  },
  {
    path: "/line",
    element: <Auth component={Line}/>
  },
  {
    path: "/proxy/:id",
    element: <Auth component={DetailProxy}/>
  },
  {
    path: "/proxy",
    element: <Auth component={Proxy}/>
  },
  {
    path: "/partner/:id",
    element: <Auth component={DetailPartner}/>
  },
  {
    path: "/partner",
    element: <Auth component={Partner}/>
  },
  {
    path: "/doc",
    element: <Auth component={Doc}/>
  },
  {
    path: "/app",
    element: <Auth component={AppList}/>
  },
  {
    path: "/privacy",
    element: <Auth component={Privacy} isGuest={true}/>
  },
  {
    path: "/terms",
    element: <Auth component={Terms} isGuest={true}/>
  },
  {
    path: "/checkproxy",
    element: <Auth component={CheckProxy} isGuest={true}/>
  },
  {
    path: "*",
    element: <>U should not here ^^ it's not exist.</>
  }
]);